import { render } from "./ZoomPad.vue?vue&type=template&id=9cce96a8&scoped=true"
import script from "./ZoomPad.vue?vue&type=script&lang=js"
export * from "./ZoomPad.vue?vue&type=script&lang=js"

import "./ZoomPad.vue?vue&type=style&index=0&id=9cce96a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cce96a8"]])

export default __exports__